<template>
  <div>
    <div style="padding: 16px; position: relative; ">
      <!-- 公司簡介 -->
      <div style="flex:1; display: flex; gap: 24px;">
        <div style="color: #666; line-height: 1.8; font-size: 16px; text-indent: 2em;">
          碼雲科技創立於2018年，深耕企業級雲計算解決方案領域。我們以「技術驅動商業進化」為使命，纍計服務超過2000家中大型企業客戶。核心團隊來自阿裏雲、騰訊雲等頂尖技術公司，擁有ISO27001信息安全認證和15項技術專利。提供從SaaS應用到私有雲定制的全棧服務，堅持7×24小時快速響應機制，連續三年獲得CSA全球雲安全聯盟五星評級。
        </div>
      </div>

      <!-- 核心優勢 -->
      <div style="margin-bottom: 24px; margin-top: 36px;">
        <div style="font-size: 22px; color: #3E4F7A; font-weight: 600; margin-bottom: 12px;">核心優勢</div>
        <div style="display: flex; gap: 16px; flex-wrap: wrap;">
          <div v-for="(item, index) in features" :key="index"
            style="flex:1; min-width: 280px; background: #F6F8FB; border-radius: 8px; padding: 12px;">
            <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 6px;">
              <div style="color: #43974E; font-weight: 800;">✓</div>
              <div style="font-weight: 600; color: #3E4F7A;">{{ item.title }}</div>
            </div>
            <div style="font-size: 13px; color: #666; line-height: 1.5;">{{ item.desc }}</div>
          </div>
        </div>
      </div>

      <!-- 服務時間 -->
      <div style="border-top: 1px solid #eee; padding-top: 16px;">
        <div
          style="display: flex; align-items: center; gap: 8px; background: #E8F5ED; padding: 8px 12px; border-radius: 6px; border: 1px solid #43974E;">
          <div style="color: #43974E; font-weight: 600;">●</div>
          <div>
            <div style="font-size: 14px; color: #3E4F7A; font-weight: 600;">全年無休服務</div>
            <div style="font-size: 12px; color: #666;">工作日9:00-18:00實時咨詢｜節假日智能值守｜緊急情況隨時響應</div>
          </div>
        </div>
      </div>
      <div style="height: 50px;"></div>
      <!-- 版權聲明 -->
      <div style="margin-top: 40px; border-top: 1px solid #eee; 
              background: #fafafa; text-align: center; position: absolute; width: 100%; bottom: 0px;">
        <div style="color: #999; font-size: 12px; line-height: 1.8;">
          <div>Copyright © 2018-2025 碼雲 版權所有</div>
          <div style="margin-top: 4px;">
            <span>技術驅動商業進化</span>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          title: "精准需求落地",
          desc: "BAT資深團隊，支持Java/Python/Go開發，3周交付可用原型"
        },
        {
          title: "靈活部署無憂",
          desc: "支持SaaS/私有化部署，提供API對接與繫統集成"
        },
        {
          title: "長效服務保障",
          desc: "7×24小時技術響應，3年免費繫統升級"
        }
      ]
    }
  }
}
</script>
